var _defs, _rect, _rect2, _path, _polygon, _rect3, _rect4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _rect5, _line8, _line9, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpCatalogNotebookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:none;}.b{fill:#3c3c46;opacity:0.2;}.c,.d,.g{fill:#fff;}.c,.d{stroke:#e5e5e5;}.c,.d,.e,.f,.g{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.c{fill-rule:evenodd;}.e{fill:#89d9fb;}.e,.f,.g{stroke:#3c3c46;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-notebook-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 32.31,
    y: 31.61,
    width: 56.11,
    height: 88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M113.69,94.74h-7V37.42a3.51,3.51,0,0,1,3.5-3.5h0a3.51,3.51,0,0,1,3.5,3.5Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "106.69 94.74 110.19 102.34 113.69 94.74 106.69 94.74"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 106.69,
    y: 40.63,
    width: 7,
    height: 4.21
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 26.31,
    y: 24.62,
    width: 56.11,
    height: 80
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 74.41,
    y1: 28.85,
    x2: 74.41,
    y2: 20.38
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 67.73,
    y1: 28.85,
    x2: 67.73,
    y2: 20.38
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 61.05,
    y1: 28.85,
    x2: 61.05,
    y2: 20.38
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 54.36,
    y1: 28.85,
    x2: 54.36,
    y2: 20.38
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 47.68,
    y1: 28.85,
    x2: 47.68,
    y2: 20.38
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 41,
    y1: 28.85,
    x2: 41,
    y2: 20.38
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 34.31,
    y1: 28.85,
    x2: 34.31,
    y2: 20.38
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 41.04,
    y: 43.5,
    width: 26.65,
    height: 18.08
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 46.81,
    y1: 50.04,
    x2: 61.91,
    y2: 50.04
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 46.81,
    y1: 55.04,
    x2: 61.91,
    y2: 55.04
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 26.31,
    y: 104.62,
    width: 56.11,
    height: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "g",
    x: 26.31,
    y: 108.62,
    width: 56.11,
    height: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpCatalogNotebookIcon);
export default __webpack_public_path__ + "static/media/CP-catalog-notebook-icon.d5ca99daa645d76a70adb549036353a9.svg";
export { ForwardRef as ReactComponent };